import { MP_REPLAY_ID_STORAGE_KEY } from '../../constants';

/**
 * Synchronously reads the Mixpanel replay id that @fiverr-private/obs writes to sessionStorage.
 * Uses native sessionStorage (not @fiverr-private/futile) so it is safe to call inline from the
 * fetch/XHR interceptor hot path. Never throws — sessionStorage access can fail in privacy modes
 * or sandboxed iframes.
 */
export const getReplayId = (): string | null => {
    try {
        return window.sessionStorage.getItem(MP_REPLAY_ID_STORAGE_KEY) || null;
    } catch {
        return null;
    }
};
